import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

// Al marcar Parcial: registra cuántas unidades de cada producto ya se fabricaron (no cambia el pedido).
export const ParcialFabDialog = ({ orderId, open, onOpenChange, onSaved }) => {
  const [items, setItems] = useState([]);
  const [vals, setVals] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!open) return;
    api.get(`/orders/${orderId}`).then(({ data }) => {
      const its = (data.items || []).map((it, i) => ({ ...it, key: `${i}:${it.product_id || ""}` }));
      setItems(its);
      setVals(Object.fromEntries(its.map((it) => [it.key, (data.fab_parcial || {})[it.key] ?? 0])));
    }).catch((e) => toast.error(formatApiError(e)));
  }, [open, orderId]);
  const save = async () => {
    setSaving(true);
    try {
      const cantidades = Object.fromEntries(Object.entries(vals).map(([k, v]) => [k, Number(v) || 0]));
      await api.patch(`/orders/${orderId}/fab-parcial`, { cantidades });
      toast.success("Unidades fabricadas registradas");
      onSaved?.(cantidades);
      onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e)); }
    setSaving(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="dialog-parcial-fab">
        <DialogHeader>
          <DialogTitle>Fabricación parcial</DialogTitle>
          <DialogDescription>Indique cuántas unidades de cada producto ya están fabricadas.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {items.map((it) => (
            <div key={it.key} className="flex items-center gap-3 text-sm">
              <div className="flex-1 uppercase text-xs">{it.product_name} {[it.tamano, it.estilo, it.color].filter(Boolean).join(" / ")}</div>
              <Input type="number" min={0} max={it.cantidad} value={vals[it.key]} onChange={(e) => setVals((p) => ({ ...p, [it.key]: Math.max(0, Math.min(it.cantidad, Number(e.target.value) || 0)) }))} className="w-20 h-8" data-testid={`parcial-qty-${it.key}`} />
              <span className="text-xs text-zinc-500 w-14">de {it.cantidad}</span>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving} data-testid="btn-omitir-parcial">Omitir</Button>
          <Button onClick={save} disabled={saving} data-testid="btn-guardar-parcial">{saving ? "Guardando..." : "Guardar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
